import type { FaireProductEntity } from "../../entity_types/product";

export const p_wg94mzvtuj: FaireProductEntity = {
  token: "p_wg94mzvtuj",
  type: "product",
  name: "Nirvana Crystal Bath Bomb",
  brandToken: "b_c9c6ucjohv",
  brandName: "Los Angeles Salt Company",
  imageUrl:
    "https://cdn.faire.com/fastly/db3781582bb2e5c38e00889b3d33e0b63c39ee9601f78098bf13346a4bbf7f22.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/644bd026f4a5299d7ee06a6efecee31fdcdcb6807b56386b1a1bc24db1db269f.jpeg",
    "https://cdn.faire.com/fastly/8e15ec4a1e94dd32c20c993c22225acbbf8371080dbb23bb9b952e7650253794.jpeg",
    "https://cdn.faire.com/fastly/212f3417385d7480a484e5a0c20f600f4ee6549f8914571c1023acc04c6a827d.jpeg",
    "https://cdn.faire.com/fastly/d0c14ccc97bb575fe5450b51617f8fc44d5b7fc8be759d9c2dd64cb70bb2ec33.jpeg",
    "https://cdn.faire.com/fastly/2f50e6bdb4536a5dc4415894b44454c678286ea4846d0b7bef634104034d5ae4.jpeg",
    "https://cdn.faire.com/fastly/8b5f19a9966fd709857ff4a6996343bee6e332699aea752e39c8b76410e725a5.jpeg",
  ],
  priceDollars: 4.97,
  description:
    "The Nirvana Crystal Skull Bath Bomb is handmade with skin-soothing Himalayan pink salt and infused with our signature seasonal scents to melt away stress and awaken the senses. Each spooky-chic bomb is topped with glittering pink salt crystals and freshly dried rose petals, making it as beautiful as it is indulgent. This fall-inspired fragrance blends sweet orange, patchouli, and rose with warm spice notes for the perfect seasonal soak. Hidden inside, a mystery crystal—energy-cleansed and ready to keep—adds a playful surprise to your self-care ritual.\n\nNotes: Citrus, Floral, Woody\n\nSize: 8oz",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:14.676Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
